import axios from 'axios';

const TrueVault = {};
const apiKey = process.env.TRUEVAULT_WRITE_API_KEY; // TODO split out for multitenant solutions
const apiKeyBase64 = Buffer.from(apiKey + ':').toString('Base64');
const authHeader = { Authorization: 'Basic ' + apiKeyBase64, 'Content-Type': 'multipart/form-data' };
const v1_base_url = 'https://api.truevault.com/v1/';
const accessTokenHeader = (accessToken) => {
  return Buffer.from(accessToken + ':').toString('Base64');
};

TrueVault.createBlob = async (vaultId, file) => {
  var bodyFormData = new FormData();
  bodyFormData.append('file', file);
  return axios({
    method: 'post',
    url: v1_base_url + 'vaults/' + vaultId + '/blobs',
    data: bodyFormData,
    headers: authHeader
  });
};

TrueVault.getBlob = async (vaultId, blobId, accessToken) => {
  return axios({
    method: 'get',
    responseType: 'arraybuffer',
    url: v1_base_url + 'vaults/' + vaultId + '/blobs/' + blobId,
    headers: { Authorization: 'Basic ' + accessTokenHeader(accessToken) }
  });
};

export default TrueVault;
